import React, { ReactElement } from "react";
import MainImg from "./mainImg";

export default function WhatIsHomeWarrantyCategoryPage(): ReactElement {
    return (
        <section className="flex flex-col lg:flex-row lg:gap-28 gap-16  lg:pt-16 pt-8 lg:px-12 px-6 lg:mt-52 mt-20 bg-[#F1F6FF]">
            <div className="max-w-[574px]  mx-auto lg:mx-0 ">
                <h2 className="font-bold lg:text-3xl text-2xl lg:leading-[45px] ">
                    What Is a Home Warranty For?
                </h2>
                <p className="mt-3    text-base lg:leading-8  font-light">
                    A home warranty is a service contract that provides coverage
                    for repairing or replacing major home systems and
                    appliances. It is designed to protect homeowners from
                    unexpected expenses that arise due to the breakdown of
                    essential household items. With a home warranty, homeowners
                    can be at ease knowing that if a covered item malfunctions
                    or stops working, they can contact their warranty provider
                    to arrange for repairs or replacements. This can save
                    homeowners from incurring high repair or replacement costs,
                    providing financial protection and added convenience for
                    their homes.
                </p>
            </div>
            <div className="w-[300px] h-[250px] md:h-[399px] md:w-[380px] md:min-w-[380px] relative mx-auto lg:mx-0 lg:bottom-24 ">
                <MainImg />
            </div>
        </section>
    );
}
